const carouselItems = [
  {
    id: 1,
    title: '2025年度塌房大盘点',
    tag: '年度专题',
    excerpt: '回顾这一年娱乐圈最震撼的塌房现场，从顶流偶像到国民老公，谁翻车翻得最彻底？吃瓜爆料网为你整理年度十大塌房事件全记录。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20year-end%20entertainment%20scandal%20collage%20with%20shattered%20glass%20effect%2C%20warm%20orange%20and%20coral%20lighting%2C%20bold%20editorial%20photography%20style%2C%20dark%20dramatic%20atmosphere%2C%20entertainment%20news%20retrospective%20visual&width=1000&height=560&seq=carousel-01-year&orientation=landscape',
  },
  {
    id: 2,
    title: '反差人设：镜头前vs镜头后的真相',
    tag: '深度专题',
    excerpt: '那些在镜头前光鲜亮丽的明星和网红，私下究竟是什么样？吃瓜爆料网独家整理反差视频合集，为你揭示娱乐圈的双面人生。',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20dramatic%20visual%20of%20celebrity%20public%20versus%20private%20life%2C%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20news%20exclusive%20feature%2C%20bold%20editorial%20style%2C%20high%20contrast%20duality%20composition&width=1000&height=560&seq=carousel-02-contrast&orientation=landscape',
  },
  {
    id: 3,
    title: '娱乐圈产业链黑幕揭秘',
    tag: '独家专题',
    excerpt: '从选角潜规则到数据造假，从资源置换到人设包装，吃瓜爆料网带你深入娱乐圈产业链背后不为人知的黑暗角落。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20behind%20the%20scenes%20of%20entertainment%20industry%20with%20dramatic%20warm%20orange%20and%20coral%20lighting%2C%20exclusive%20investigation%20visual%2C%20editorial%20photography%20style%2C%20mysterious%20shadowy%20atmosphere&width=1000&height=560&seq=carousel-03-industry&orientation=landscape',
  },
  {
    id: 4,
    title: '品牌代言翻车全记录',
    tag: '热门专题',
    excerpt: '当明星塌房，品牌如何紧急止损？吃瓜爆料网梳理近年来最惨烈的品牌解约潮，看看哪些品牌被坑得最惨。',
    image: 'https://readdy.ai/api/search-image?query=Brand%20billboard%20being%20removed%20in%20dramatic%20urban%20night%20scene%2C%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20sponsorship%20scandal%20visual%2C%20editorial%20photography%20style%2C%20corporate%20crisis%20atmosphere&width=1000&height=560&seq=carousel-04-brand&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-500">深度梳理 · 吃瓜也要吃出水平</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <article key={item.id} className="group relative bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all">
              <div className="w-full aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}